// Lista dealerów Škoda biorących udział w odkupie samochodów dla formularza Trade-in (KVPS codes)
export const dealers = [
  { value: "", label: "Wybierz dealera", voivodeship: "" },
  {
    value: "20110C",
    label: "Fiedorowicz (Polbis Olsztyn) - Olsztyn, ul. Sielska 42",
    voivodeship: "warminsko-mazurskie",
  },
  {
    value: "20220C",
    label: "Wątarski Włocławek - Włocławek, ul. Toruńska 169",
    voivodeship: "kujawsko-pomorskie",
  },
  {
    value: "20270C",
    label: "Porsche Inter Auto Poznań (Obornicka) - Poznań, ul. Obornicka 249",
    voivodeship: "wielkopolskie",
  },
  {
    value: "20310C",
    label: "Lellek Opole - Opole, ul. Opolska 2C",
    voivodeship: "opolskie",
  },
  {
    value: "20340C",
    label: "Ignaszak Kalisz - Kalisz, al. Wojska Polskiego 5",
    voivodeship: "wielkopolskie",
  },
  // { value: "20350C", label: "Auto Śliwka Katowice - Katowice, ul. Kościuszki 94", voivodeship: "slaskie" },
  {
    value: "20360C",
    label: "Krotoski Częstochowa - Częstochowa, ul. Makuszyńskiego 74/76",
    voivodeship: "slaskie",
  },
  {
    value: "20390C",
    label:
      "Zimny Auto Piotrków Trybunalski - Piotrków Trybunalski, ul. Wojska Polskiego 102",
    voivodeship: "lodzkie",
  },
  // { value: "20420C", label: "Fimot Ełk - Ełk, ul. Podmiejska 1", voivodeship: "warminsko-mazurskie" },
  {
    value: "20470C",
    label: "Carsed Siedlce - Siedlce, ul. Brzeska 181 A",
    voivodeship: "mazowieckie",
  },
  {
    value: "20540C",
    label: "Lellek Tarnowskie Góry - Tarnowskie Góry, ul. Leśna 2",
    voivodeship: "slaskie",
  },
  {
    value: "20580C",
    label:
      "Porsche Inter Auto Warszawa Połczyńska - Warszawa, ul. Połczyńska 125",
    voivodeship: "mazowieckie",
  },
  {
    value: "20590C",
    label: "Zimny Auto Łódź - Łódź, ul. Rzgowska 142/146",
    voivodeship: "lodzkie",
  },
  {
    value: "20600C",
    label: "Auto Park Piła - Piła, ul. Henryka Siemiradzkiego 23",
    voivodeship: "wielkopolskie",
  },
  // { value: "20640C", label: "Gall Wrocław - Wrocław, ul. Armii Krajowej 46", voivodeship: "dolnoslaskie" },
  {
    value: "20660C",
    label: "Plichta Wejherowo - Wejherowo, ul. Gdańska 13C",
    voivodeship: "pomorskie",
  },
  {
    value: "20700C",
    label:
      "Bieranowski Bydgoszcz Jana Pawła II - Bydgoszcz, ul. Jana Pawła II 127",
    voivodeship: "kujawsko-pomorskie",
  },
  {
    value: "20800C",
    label: "Lellek Koźle - Kędzierzyn-Koźle, ul. Bolesława Chrobrego 25",
    voivodeship: "opolskie",
  },
  {
    value: "20830C",
    label: "Jarzyński Ciechanów - Ciechanów, ul. Kasprzaka 5",
    voivodeship: "mazowieckie",
  },
  {
    value: "20870C",
    label: "G&G Świdnik - Świdnik, ul. Piasecka 20a",
    voivodeship: "lubelskie",
  },
  {
    value: "20880C",
    label: "Plichta Gdynia Morska 80 - Gdynia, ul. Morska 80",
    voivodeship: "pomorskie",
  },
  {
    value: "20900C",
    label: "HADM Starogard Gdański - Starogard Gdański, ul. Rokocin 4G",
    voivodeship: "pomorskie",
  },
  {
    value: "20920C",
    label:
      "Korczyk Bielsko-Biała - Bielsko-Biała, ul. gen. Władysława Andersa 586",
    voivodeship: "slaskie",
  },
  {
    value: "20970C",
    label: "Żagiel Lublin - Lublin, ul. Roztocze 4",
    voivodeship: "lubelskie",
  },
  {
    value: "20980C",
    label: "Plichta Toruń - Lubicz Dolny, ul. Toruńska 85",
    voivodeship: "kujawsko-pomorskie",
  },
  {
    value: "21010C",
    label: "Centrum TMT Dzierżoniów - Dzierżoniów, ul. Świdnicka 151",
    voivodeship: "dolnoslaskie",
  },
  {
    value: "21220C",
    label: "Carsed Stojadła - Stojadła, ul. Warszawska 84",
    voivodeship: "mazowieckie",
  },
  {
    value: "21410C",
    label: "Lellek Gliwice - Gliwice, ul. Portowa 2",
    voivodeship: "slaskie",
  },
  {
    value: "21440C",
    label: "Auto Śliwka Zabrze - Zabrze, ul. Plutonowego Szkubacza 4",
    voivodeship: "slaskie",
  },
  {
    value: "21490C",
    label: "GCZ Poznań Unii Lubelskiej - Poznań, ul. Unii Lubelskiej 5",
    voivodeship: "wielkopolskie",
  },
  {
    value: "21500C",
    label: "Plichta Gdańsk Grunwaldzka - Gdańsk, ul. Grunwaldzka 339",
    voivodeship: "pomorskie",
  },
  {
    value: "21540C",
    label: "Auto Bączek Tarnów - Tarnów, ul. Gumniska 36a",
    voivodeship: "malopolskie",
  },
  {
    value: "21570C",
    label: "Autorud Kielce - Kielce, ul. Krakowska 283",
    voivodeship: "swietokrzyskie",
  },
  {
    value: "21610C",
    label: "Ciesiółka Leszno - Leszno, al. Konstytucji 3 Maja 13",
    voivodeship: "wielkopolskie",
  },
  {
    value: "21730C",
    label: "Centrum TMT Wrocław - Wrocław, ul. Horbaczewskiego 75",
    voivodeship: "dolnoslaskie",
  },
  {
    value: "21780C",
    label: "PIA Katowice - Świętochłowice, ul. Drogowa Trasa Średnicowa 2",
    voivodeship: "slaskie",
  },
  {
    value: "21880C",
    label: "Plichta Gdańsk Lubowidzka - Gdańsk, ul. Lubowidzka 46",
    voivodeship: "pomorskie",
  },
  {
    value: "21940C",
    label: "Auto Forum Płock - Płock, ul. Skrzetuskiego 11",
    voivodeship: "mazowieckie",
  },
  {
    value: "22000C",
    label: "Bednarek Łódź - Łódź, ul. Szczecińska 36/38A",
    voivodeship: "lodzkie",
  },
  {
    value: "22010C",
    label: "Bednarek Dobroń - Dobroń, ul. Wrocławska 18",
    voivodeship: "lodzkie",
  },
  {
    value: "22040C",
    label: "L'emir Dąbrowa Górnicza - Dąbrowa Górnicza, ul. Sobieskiego 10A",
    voivodeship: "slaskie",
  },
  {
    value: "22050C",
    label: "Bohemia Motors Falenty - Janki k. Warszawy, al. Krakowska 5a",
    voivodeship: "mazowieckie",
  },
  {
    value: "22060C",
    label: "Auto Gazda Rybnik - Rybnik, ul. Żorska 11A",
    voivodeship: "slaskie",
  },
  {
    value: "22120C",
    label: "PIA Tychy - Tychy, ul. Beskidzka 105",
    voivodeship: "slaskie",
  },
  {
    value: "22160C",
    label: "KIM Zielona Góra - Zielona Góra, ul. Kostrzyńska 6",
    voivodeship: "lubuskie",
  },
  {
    value: "22180C",
    label: "Centrum Wrocław - Wrocław, al. Brucknera 40-46",
    voivodeship: "dolnoslaskie",
  },
  {
    value: "22240C",
    label: "HADM Elbląg - Elbląg, ul. Warszawska 87",
    voivodeship: "warminsko-mazurskie",
  },
  {
    value: "22260C",
    label: "Motorpol Wrocław - Wrocław, Aleja Karkonoska 81",
    voivodeship: "dolnoslaskie",
  },
  {
    value: "22400C",
    label: "Plichta Gdańsk Letnica - Gdańsk, ul. Marynarki Polskiej 94",
    voivodeship: "pomorskie",
  },
  {
    value: "22430C",
    label: "Bieranowski Bydgoszcz Kamienna - Bydgoszcz, ul. Kamienna 78",
    voivodeship: "kujawsko-pomorskie",
  },
  {
    value: "22460C",
    label: "Auto BZ Łódź - Łódź, ul. Brzezińska 17",
    voivodeship: "lodzkie",
  },
];
